import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    toolbar: {
      flexDirection: 'row',
      alignContent: 'center',
      alignItems: 'center',
      marginBottom: 24,
    },
    filters: {
      flexGrow: 0,
      maxWidth: '50%',
      flexBasis: '50%',

      '@media (max-width: 1181px)': {
        maxWidth: '81%',
        flexBasis: '81%',
      },
    },
  }),
);
